/**
 * Get Currencies Use Case
 * Orchestrates fetching available currencies
 */

import { CurrenciesRepository } from '../data/currencies-repository';
import { CurrencyItem } from '../types/currencies-types';

export class GetCurrenciesUseCase {
  constructor(private repository: CurrenciesRepository) {}

  async execute(): Promise<CurrencyItem[]> {
    return this.repository.getAvailableCurrencies();
  }
}
